module.exports = __webpack_public_path__ + "img/partheas_zw_logo.8a284af5.png";